import { render, staticRenderFns } from "./NodeDialogForm.vue?vue&type=template&id=c22898be&"
import script from "./NodeDialogForm.vue?vue&type=script&lang=ts&"
export * from "./NodeDialogForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports